
$(function() {
	var linksToAnchors = $('*:not(.owl-carousel) a[href*="#"]');
	function anchorLinkHandler(e) {
		let href = $(this).prop('hash');
		let pathname = $(this).prop('pathname');
		let $where = $(href);
		if ($where.length && $($where).hasClass('is-style-modal-content')) {
			$($where).modal({fadeDuration: 500,
				fadeDelay: 0.50});
			return false;
		}
	}
	if (linksToAnchors.length) {
		linksToAnchors.on('click', anchorLinkHandler);
	}
});